import styled from "@emotion/styled";
import { keyframes, css } from "@emotion/react";

export const HealthBannerfadeOut = keyframes`
  from {
    opacity: 1;
    transform: scaleY(1);
    height: auto;
  }
  to {
    opacity: 0;
    transform: scaleY(0);
    height: 0;
    margin: 0;
    padding: 0;
  }
`;

export const HealthBannerWrapper = styled.div<{ isClosing: boolean }>`
  position: relative;
  width: 100%;
  overflow: hidden;
  transform-origin: top;
  margin 0 auto;
  cursor: pointer;


  ${({ isClosing }) =>
    isClosing &&
    css`
      animation: ${HealthBannerfadeOut} 1s ease forwards;
    `}
`;
export const HealthBannerWrapperArticle = styled.div<{ isClosing: boolean }>`
  position: relative;
  width: 100%;
  overflow: hidden;
  transform-origin: top;
  max-width:1168px;
  margin 0 auto;
  cursor: pointer;


  ${({ isClosing }) =>
    isClosing &&
    css`
      animation: ${HealthBannerfadeOut} 1s ease forwards;
    `}
`;
export const HealthBannerStyledImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  border-radius: 8px;
`;
export const HealthBannerCloseIcon = styled.span`
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: 22px;
  color: #000;
  border-radius: 50%;
  padding: 4px 8px;
  cursor: pointer;
  z-index: 2;
`;
export const HealthBannerAnchor = styled.a`
  display: block;
  position: relative;
`;
